var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMoon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#294EBB",
  fillOpacity: 0.352,
  d: "M8.813 22.532c7.576 0 13.717-6.142 13.717-13.719 0-3.357-1.21-6.428-3.211-8.813 6.184 1.986 10.663 7.778 10.663 14.622 0 8.484-6.877 15.36-15.36 15.36C7.778 29.982 1.985 25.504 0 19.32a13.66 13.66 0 0 0 8.813 3.212"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7B93D4",
  d: "M24.115 2.567a15.27 15.27 0 0 1 3.29 9.477c0 8.483-6.877 15.36-15.36 15.36a15.26 15.26 0 0 1-9.478-3.29c2.81 3.569 7.16 5.868 12.056 5.868 8.483 0 15.36-6.876 15.36-15.36 0-4.895-2.3-9.244-5.868-12.055"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7B93D4",
  d: "M7.688 5.997 9.27 9.204l3.538.514-2.56 2.496.604 3.524-3.164-1.664-3.165 1.664.603-3.524-2.56-2.496 3.539-.514zm8.924-1.027.82 1.663 1.834.266-1.327 1.294.313 1.826-1.64-.862-1.64.862.313-1.826L13.957 6.9l1.835-.266z"
}))));
export default SvgMoon;